// extracted by mini-css-extract-plugin
export default {"volumeSlider":"iw_ix","volumeSlider__sliderContainer":"iw_iy"};